import { logEvent } from './analytics';

export const ANALYTICS_EVENTS = {
  SIGN_UP: 'sign_up',
  EMAIL_VERIFIED: 'email_verified',
  LIST_CREATED: 'list_created',
  ITEM_ADDED: 'item_added',
  FIRST_ITEM_ADDED: 'first_item_added',
  LIST_SHARED: 'list_shared',
  BARCODE_SCAN: 'barcode_scan',
  PREMIUM_PAYWALL_VIEW: 'premium_paywall_view',
  CHECKOUT_START: 'checkout_start',
  PURCHASE_COMPLETED: 'purchase_completed',
  RECURRING_CREATED: 'recurring_created',
} as const;

export type AnalyticsEventName = typeof ANALYTICS_EVENTS[keyof typeof ANALYTICS_EVENTS];

export const trackSignUp = () => logEvent(ANALYTICS_EVENTS.SIGN_UP);
export const trackEmailVerified = () => logEvent(ANALYTICS_EVENTS.EMAIL_VERIFIED);
export const trackListCreated = () => logEvent(ANALYTICS_EVENTS.LIST_CREATED);
export const trackItemAdded = (params: { first_item?: boolean } = {}) =>
  logEvent(ANALYTICS_EVENTS.ITEM_ADDED, params);
export const trackFirstItemAdded = () => logEvent(ANALYTICS_EVENTS.FIRST_ITEM_ADDED);
export const trackListShared = () => logEvent(ANALYTICS_EVENTS.LIST_SHARED);
export const trackBarcodeScan = (method: 'camera' | 'manual') =>
  logEvent(ANALYTICS_EVENTS.BARCODE_SCAN, { method });
export const trackPremiumPaywallView = (feature?: string) =>
  logEvent(ANALYTICS_EVENTS.PREMIUM_PAYWALL_VIEW, feature ? { feature } : {});
export const trackCheckoutStart = () => logEvent(ANALYTICS_EVENTS.CHECKOUT_START);
export const trackPurchaseCompleted = () => logEvent(ANALYTICS_EVENTS.PURCHASE_COMPLETED);
export const trackRecurringCreated = () => logEvent(ANALYTICS_EVENTS.RECURRING_CREATED);
